// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "client-editor/" + ({"4283":"MAProgramList","9016":"wix-ricos-http-client-fallback"}[chunkId] || chunkId) + ".chunk.min.js";
};